import styled from '@emotion/styled';

import {FloatingFocusManager} from '@floating-ui/react';

import theme from 'theme';
import {SizeTokenValue} from 'common';

import {ModalOverlay} from './ModalOverlay';
import {useModal} from './hook';

import type {ModalProps} from './types';

const Container = styled.div<Pick<ModalProps, 'size'>>`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${theme.colors.white};
  max-width: calc(100% - 40px);
  max-height: calc(100% - 40px);
  box-shadow: ${theme.shadows.medium};
  z-index: ${theme.zIndex.modal};

  ${({size = SizeTokenValue.Medium}) => {
    let width = size;

    switch (size) {
      case SizeTokenValue.XLarge:
        width = 1160;
        break;
      case SizeTokenValue.Large:
        width = 920;
        break;
      case SizeTokenValue.Medium:
        width = 620;
        break;
      case SizeTokenValue.Small:
        width = 440;
        break;
    }

    return {width};
  }}
`;

export const Modal: React.FC<ModalProps> = props => {
  const {className, isOpen, children, size, qa = 'modal'} = props;

  const {floating, floatingI, hasTarget} = useModal(props);

  const child = () => {
    const containerProps = {
      ...floatingI.getFloatingProps(),

      className,
      size,
      children,

      style: hasTarget ? floating.floatingStyles : undefined,

      'data-qa': qa,
    };

    return (
      <FloatingFocusManager context={floating.context} disabled={!isOpen}>
        <Container ref={floating.refs.setFloating} {...containerProps} />
      </FloatingFocusManager>
    );
  };

  return <ModalOverlay {...props}>{child}</ModalOverlay>;
};
